import { get, post } from '../utils/networking';
import type { ReminderDelivery } from './workEnvironmentTypes';

export type ReminderAudience = 'owner' | 'safetyRep';

export type MeasureDeadline = {
  id: number;
  title: string;
  team: string;
  teamId: number;
  surveyId: number;
  area: string;
  dueDate: string;
  /** Negative when the deadline has passed */
  daysLeft: number;
  owner: { email: string; role: 'TEAM_LEADER' | 'SAFETY_REP' } | null;
  safetyReps: string[];
  /** Why no one acts as safety representative for the team. Missing from older backends. */
  safetyRepMissing?: 'leaderIsSafetyRep' | 'noSafetyRep' | 'notUsed' | null;
  reminded: Record<ReminderAudience, string | null>;
  canRemind: Record<ReminderAudience, boolean>;
};

const PATH = '/api/hr/work-environment-measures';

export const getMeasureDeadlines = (language: string) =>
  get<MeasureDeadline[]>(`${PATH}?language=${encodeURIComponent(language)}`);

export const remindAboutMeasure = (measureId: number, to: ReminderAudience) =>
  post<ReminderDelivery>(`${PATH}/${measureId}/reminders`, { to });
